<template>
  <div class="product-center">
    <div class="title-box">
      <div class="title"> 产品世界 </div>
      <div class="heng"></div>
    </div>
    
    <van-tabs :ellipsis='false' type="card">
      <van-tab v-for="(item,idx) in tabList" :key="idx">
        <template #title> 
          <img class="tabs-img" :src="item.class_image" alt="">
          {{item.class_name}} 
        </template>
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item v-for="(item1,idx1) in item.class_list" :key="idx1" :title="item1.class_name" :name="item1.lead_product_id">
            <template #value>
              <img class="collapse-img" :src="item1.price_img" alt="">
              {{item1.pro_name}}
            </template>
            <div @click="topath(item1.lead_product_id)" class="detiles">
              <img class="detiles-img" :src="item1.price_img" alt="">
              <p class="detiles-title">{{item1.pro_name}}</p>
              <!-- <span class="detiles-text1">官方建议零售价：</span> -->
              <!-- <span class="detiles-text2">{{item1.price}}</span> -->
            </div>
          </van-collapse-item>
        </van-collapse>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { getProductsDropDownApi } from "@/api/api";
import { Tab, Tabs } from 'vant';
import { Collapse, CollapseItem } from 'vant';
export default {
  name:'productCenter',
  components:{
    [Tab.name]:Tab,
    [Tabs.name]:Tabs,
    [Collapse.name]:Collapse,
    [CollapseItem.name]:CollapseItem,
  },
  data(){
    return{
      activeNames:'',
      tabList:[]
    }
  },
  created(){
    this.getProductsDropDownApi()
  },
  methods:{
    // 产品世界数据
    getProductsDropDownApi(){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'production_class_list',
        lang:1
      }
      getProductsDropDownApi(params).then(({data})=>{
        this.tabList = data.datas.info
      })
    },
    topath(val){
      this.$router.push({
					path:"/particulars",
					query:{id:val}
			})
    }
  }
}
</script>
<style lang="scss">
@import './productCenter.scss';
</style>